import React from 'react';
import { Heart } from 'lucide-react';
import { useWishlist } from '../context/WishlistContext';

export default function CardWishlistButton({ product }) {
  const { toggleWishlist, isInWishlist } = useWishlist();
  const isWishlisted = isInWishlist(product.id);

  return (
    <button
      onClick={(e) => {
        e.preventDefault(); // Prevents triggering parent Link navigation
        toggleWishlist(product);
      }}
      className={`group relative p-2.5 rounded-full backdrop-blur-xl transition-all duration-300 shadow-sm hover:shadow-md active:scale-90 flex items-center justify-center ${
        isWishlisted 
          ? 'bg-rose-500 text-white shadow-rose-500/30' 
          : 'bg-white/90 hover:bg-white text-gray-700 hover:text-rose-500 border border-gray-100/80'
      }`}
      title={isWishlisted ? "Remove from Wishlist" : "Add to Wishlist"}
    >
      <Heart 
        className={`h-4 w-4 transition-transform duration-300 group-hover:scale-110 ${
          isWishlisted ? 'fill-current text-white scale-105' : 'stroke-[2]'
        }`} 
      />
    </button>
  );
}